import { Card } from 'antd'
import { CardProps as AntdCardProps } from 'antd/lib/card'
import * as React from 'react'
import * as styles from './ContainerMenu.module.less'

export interface CardProps extends AntdCardProps {
	fitContent?: boolean
}

export interface ContainerMenuProps {
	cardProps?: CardProps
	menu?: JSX.Element
}

export const ContainerMenu: React.FC<ContainerMenuProps> = (props) => {
	const { cardProps, children, menu } = props
	let className = menu ? styles.containerMenu : styles.containerMenuNoTitle
	if (cardProps) {
		className = cardProps.fitContent ? `${className}` : `${className} ${styles.fitContainer}`
	}

	return (
		<Card bordered={false} className={className} title={menu} {...cardProps}>
			{children}
		</Card>
	)
}
